var generateStyle = function generateStyle(componentTheme) {
  return {
    column: {
      display: 'flex',
      flexFlow: 'column'
    },
    firstNumberSummary: {
      paddingBottom: "".concat(componentTheme.firstNumberSummaryPadding)
    },
    secondNumberSummary: {
      paddingTop: "".concat(componentTheme.secondNumberSummaryPadding)
    },
    numberSummary: {
      color: componentTheme.numberSummaryColor,
      fontSize: componentTheme.numberSummaryFontSize,
      fontWeight: componentTheme.numberSummaryFontWeight,
      margin: 'auto'
    },
    verticalDots: {
      margin: 'auto',
      height: '1.5rem',
      borderLeft: "dotted ".concat(componentTheme.verticalDotsBorderWidth),
      borderColor: componentTheme.verticalDotsBorderColor
    }
  };
};
export default generateStyle;